import { enableMapSet } from 'immer'
import { deepFreeze } from './immutability'

enableMapSet()

/**
 * Has stable reference - passes ref equality comparisons
 */
export const STABLE_EMPTY_ARRAY = deepFreeze([])

/**
 * Has stable reference - passes ref equality comparisons
 */
export const STABLE_EMPTY_OBJECT = deepFreeze({})

/**
 * Has stable reference - passes ref equality comparisons
 */
export const STABLE_EMPTY_SET = deepFreeze(new Set<any>())

export function getBotDeleteGracePeriodMs(): number {
  return 30 * 24 * 60 * 60 * 1000
}
